import type { SettingsMenuContainer } from '../settings-menu-container'

import { register } from '|>/shared/vjs'
import { BaseMenu } from '../../base'
import { LocalEvents } from '../local-events'
import { SettingsBackTitle } from '../settings-back-title'
import { SettingsSubtitlesCustomItem } from './settings-subtitles-custom-item'
import { SettingsSubtitlesLanguageItem } from './settings-subtitles-language-item'

/**
 * Settings main menu with audio and subtitles items
 */
@register
export class SettingsSubtitlesMenu extends BaseMenu {
  declare container: SettingsMenuContainer | undefined

  // menu items
  declare backTitle: SettingsBackTitle
  declare subtitlesLanguageItem: SettingsSubtitlesLanguageItem
  declare subtitlesCustomItem: SettingsSubtitlesCustomItem

  update() {
    this.subtitlesLanguageItem.update()
    this.backTitle.container = this.container
    this.subtitlesLanguageItem.container = this.container
    this.subtitlesCustomItem.container = this.container
  }

  activate() {
    this.addClass('vjs-x-active')
  }

  deactivate() {
    this.removeClass('vjs-x-active')
  }
}

SettingsSubtitlesMenu.options = {
  className: 'vjs-x-settings-main-menu vjs-menu',
  children: [
    SettingsBackTitle.as('backTitle', {
      backEvent: LocalEvents.SettingsActivateMainMenu,
      title: 'subtitles_closed_captions',
    }),

    // subtitles menu item
    SettingsSubtitlesLanguageItem.as('subtitlesLanguageItem'),

    // subtitles custom menu item
    SettingsSubtitlesCustomItem.as('subtitlesCustomItem'),
  ],
}
